'use client';

import { useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

export function useContactModal() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const query = searchParams.toString();
    const requested = searchParams.get('contact') === 'true';
    const [state, setState] = useState({ query, open: requested });
    if (state.query !== query) setState({ query, open: requested || state.open });

    useEffect(() => {
        if (searchParams.get('contact') !== 'true') return;
        const nextParams = new URLSearchParams(searchParams.toString());
        nextParams.delete('contact');
        const query = nextParams.toString();
        router.replace(
            `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`,
            { scroll: false },
        );
    }, [router, searchParams]);

    return { open: state.open, setOpen: (open: boolean) => setState((current) => ({ ...current, open })) };
}
